import dayjs from 'dayjs'
import 'dayjs/locale/fr'

// Terse relative-time label for a departure, matching the previous moment.js
// output exactly: "<1" (<59s), "N'" minutes (up to 58'), ">Nh" hours (from 59min
// on), prefixed with "Il y a " when the time is in the past.
export const useTimeDifference = (item: any) => {
  const time = item?.rt || item?.th
  const now = dayjs()
  const target = dayjs(time)
  const isFuture = target.valueOf() > now.valueOf()
  const seconds = Math.floor(Math.abs(now.diff(target)) / 1000)

  let magnitude: string
  if (seconds < 59) magnitude = '<1'
  else if (seconds < 3540)
    magnitude = `${Math.max(1, Math.floor(seconds / 60))}'`
  else magnitude = `>${Math.max(1, Math.floor(seconds / 3600))}h`

  return isFuture ? magnitude : `Il y a ${magnitude}`
}

export const useMoreThanAHour = (departure: any) => {
  const time = departure?.rt || departure?.th
  return !!dayjs().diff(dayjs(time), 'hours')
}

export const useLessThanOneMinute = (departure: any) => {
  const time = departure?.rt || departure?.th

  return !dayjs().diff(dayjs(time), 'minutes')
}

export const useLessThanHalfAMinute = (departure: any) => {
  const time = departure?.rt || departure?.th
  return dayjs().diff(dayjs(time), 'seconds') > -30
}

export const useOutdated = (departure: any) => {
  const time = departure?.rt || departure?.th
  const now = dayjs()
  const bus = dayjs(time)
  return now.diff(bus, 'seconds') >= 0
}

export const useNow = () => {
  dayjs.locale('fr')
  return dayjs().format('dddd D MMMM HH:mm:ss')
}
